import FlexBox from 'components/Shared/Container/FlexBox';
import Icon from 'components/Shared/Icon/Icon';
import PropertyField from 'components/Shared/PropertyField';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
const BackgroundContainer = styled(FlexBox) `
  padding: 16px;
  align-items: flex-start;
  flex-direction: column;
  gap: 8px;
  border-radius: 6px;
  background: ${({ theme }) => theme.palette.grey[10]};
`;
const Tag = styled(FlexBox) `
  border-radius: 4px;
  gap: 4px;
  padding: 4px 8px;
  background: ${({ theme }) => theme.palette.grey[0]};
  & :first-of-type {
    color: ${({ theme }) => theme.backgrounds.grey};
  }
`;
const FarmSiteListItemContent = ({ farmSite, }) => {
    const { t } = useTranslation();
    const _workerSummary = !!farmSite.ownersWorkersSummary
        ? farmSite.ownersWorkersSummary
        : farmSite.workersSummary;
    const allFarmerTrainings = _workerSummary === null || _workerSummary === void 0 ? void 0 : _workerSummary.trainings;
    const shownFarmerTrainings = (allFarmerTrainings === null || allFarmerTrainings === void 0 ? void 0 : allFarmerTrainings.sort((a, b) => b.percentageCompleted - a.percentageCompleted).slice(0, 3)) || [];
    return (React.createElement(React.Fragment, null,
        React.createElement(FlexBox, { gap: 2, flexWrap: "wrap" },
            farmSite.size > 0 && (React.createElement(PropertyField, { label: t('farm-size'), value: `${farmSite.size} ${t('units.hectares')}` })),
            farmSite.productiveSize > 0 && (React.createElement(PropertyField, { label: t('productive-area'), value: `${Math.round(farmSite.productiveSize * 100) / 100} ${t('units.hectares')}` })),
            typeof farmSite.directAccessToWater === 'boolean' && (React.createElement(PropertyField, { label: t('direct-access-to-safe-drinking-water'), value: React.createElement(FlexBox, { gap: 0.5 },
                    React.createElement(Icon, { color: farmSite.directAccessToWater ? 'green' : 'grey-40', name: farmSite.directAccessToWater
                            ? 'check-filled'
                            : 'error-filled' }),
                    t(farmSite.directAccessToWater ? 'yes' : 'no')) })),
            typeof farmSite.accessToSanitationFacilities === 'boolean' && (React.createElement(PropertyField, { label: t('access-to-sanitation-facilities'), value: React.createElement(FlexBox, { gap: 0.5 },
                    React.createElement(Icon, { color: farmSite.accessToSanitationFacilities ? 'green' : 'grey-40', name: farmSite.accessToSanitationFacilities
                            ? 'check-filled'
                            : 'error-filled' }),
                    t(farmSite.accessToSanitationFacilities ? 'yes' : 'no')) }))),
        _workerSummary && (React.createElement(BackgroundContainer, { mt: 2 },
            React.createElement(FlexBox, { gap: 1 },
                React.createElement(Icon, { name: "group", size: "large" }),
                !!farmSite.ownersWorkersSummary
                    ? t('farm-owner-insights')
                    : t('farmer-insights')),
            React.createElement(FlexBox, { width: "100%", alignItems: "flex-start", flexWrap: "wrap", gap: 2 },
                React.createElement(PropertyField, { label: !!farmSite.ownersWorkersSummary ? t('age') : t('average-age'), value: Math.round(_workerSummary === null || _workerSummary === void 0 ? void 0 : _workerSummary.averageAge) || '-' }),
                React.createElement(PropertyField, { label: t('biological-sex'), value: React.createElement(FlexBox, { gap: 0.5 },
                        !!farmSite.ownersWorkersSummary && (React.createElement(React.Fragment, null,
                            (_workerSummary === null || _workerSummary === void 0 ? void 0 : _workerSummary.womanPercentage) > 51
                                ? _workerSummary === null || _workerSummary === void 0 ? void 0 : _workerSummary.womanPercentage
                                : 100 - (_workerSummary === null || _workerSummary === void 0 ? void 0 : _workerSummary.womanPercentage) || '-',
                            "%")),
                        React.createElement(Icon, { name: (_workerSummary === null || _workerSummary === void 0 ? void 0 : _workerSummary.womanPercentage) > 51 ? 'female' : 'male' })) }),
                React.createElement(PropertyField, { label: !!farmSite.ownersWorkersSummary
                        ? t('number-of-children')
                        : t('average-number-of-children'), value: Math.round((_workerSummary === null || _workerSummary === void 0 ? void 0 : _workerSummary.numberOfChildren) * 10) / 10 }),
                React.createElement(PropertyField, { label: t('farmer-trainings'), value: React.createElement(FlexBox, { gap: 1, flexDirection: "column", alignItems: "flex-start" }, shownFarmerTrainings.map(({ title, percentageCompleted }) => (React.createElement(Tag, { key: title },
                        React.createElement("span", null,
                            title,
                            ":"),
                        React.createElement("span", null,
                            percentageCompleted,
                            "%"))))) }))))));
};
export default FarmSiteListItemContent;
